import { Link } from 'react-router-dom';
import Icon from './Icon';
import SkeletonImage from './SkeletonImage';
import { HERO } from '../constants/content';

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="shell">
        <p className="hero__kicker">{HERO.kicker}</p>
        <h1 className="hero__title">{HERO.title}</h1>

        <div className="hero__grid">
          <div className="hero__figure">
            <SkeletonImage
              src={HERO.image}
              alt="Printer ready for setup"
              loading="eager"
              width={900}
              height={600}
              sizes="(max-width: 768px) 100vw, 55vw"
              fetchPriority="high"
            />
          </div>

          <div className="hero__cards">
            {HERO.cards.map((card) => (
              <Link className="pill" to="/form" key={card.title}>
                <span className={`pill__icon pill__icon--${card.tone}`}>
                  <Icon name={card.icon} size={20} />
                </span>
                <span className="pill__text">
                  <strong>{card.title}</strong>
                  <small>{card.text}</small>
                </span>
                <span className="pill__arrow" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h13" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
